import React from "react";
import "./styles/SmartGreen.scss";
import TitleFormat from "../../../components/TitleFormat";
// import NetZeroScope from "../../../components/NetZeroScope";
// import DtContent from "../../../components/DtContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const SmartGreen = () => {
  const { t } = useTranslation();
  const title = { text: t("digitalTwin.smartGreen.title"), path: "" };
  const processNetzeroGoal = t("digitalTwin.smartGreen.process.content", { returnObjects: true }) as { name: string; backgroundImage: string; goals: string[] }[];
  const esgKey = t("digitalTwin.smartGreen.esgKey.content.key", { returnObjects: true }) as { imagePath: string; name: string; list: string[] }[];
  const esgCard = t("digitalTwin.smartGreen.esgKey.content.card", { returnObjects: true }) as { title: string; list: string[] }[];
  const stepByStepScope = t("digitalTwin.smartGreen.scope.content.scope", { returnObjects: true }) as { ment: string; iconPath: string }[];
  const stepByStepGreenhouseGas = t("digitalTwin.smartGreen.scope.content.greenhouseGas.strategy", { returnObjects: true }) as string[][];
  const technologyStandardization = t("digitalTwin.smartGreen.standardization.content", { returnObjects: true }) as { category: string; imagePath: string; color: string; list: { name: string; des: string }[] }[];
  return (
    <>
      <Seo title={`${t("digitalTwin.smartGreen.seo.title")}`} description={`${t("digitalTwin.smartGreen.seo.des")}`} path="digital-transformation/smart-green-esg" />
      <TitleFormat text={title.text} background={title.path} />
      <div id="smart_green_wrap">
        <div className="title_wrap">
          <h1 className="title">{t("digitalTwin.smartGreen.netZeroGoal.title")}</h1>
          <h2 className="des">{t("digitalTwin.smartGreen.netZeroGoal.sub")}</h2>
        </div>
        <div className="detail_wrap">
          <div className="detail">{t("digitalTwin.smartGreen.netZeroGoal.des")}</div>
          <div className="img_box">
            <img src="/imgs/banner_netzero.png" alt="netzero" />
          </div>
        </div>
        <div className="process_netzero_goal_wrap">
          <div className="title">{t("digitalTwin.smartGreen.process.title")}</div>
          <div className="content">
            {processNetzeroGoal.map((data, index) => {
              return (
                <div className="card" style={{ backgroundImage: `url(${data.backgroundImage})` }} key={`processNetzeroGoal_${data.name}_${index}`}>
                  <div className="name">{data.name}</div>
                  <div className="goals_wrap">
                    {data.goals.map((goal, index2) => {
                      return (
                        <div className="goal" key={`goal_${goal}_${index}_${index2}`}>
                          {goal}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="esg_key_indicators_wrap">
          <div className="title">{t("digitalTwin.smartGreen.esgKey.title")}</div>
          <div className="contents">
            <div className="esg_wrap">
              {esgKey.map((esg, index) => {
                return (
                  <div className="esg" key={`esg_key_indicators_${index}`}>
                    <div className="img_box">
                      <img src={esg.imagePath} alt="esg" />
                    </div>
                    <div className="name">{esg.name}</div>
                    <ul>
                      {esg.list.map((li, index2) => {
                        return <li key={`esg_list_${li}_${index2}`}>{li}</li>;
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
            <div className="card_wrap">
              {esgCard.map((data, index) => {
                return (
                  <div className="card" key={`data.title_${index}`}>
                    <div className="title">{data.title}</div>
                    <ul className="list">
                      {data.list.map((li, index2) => {
                        return <li key={`list_${li}_${index2}`}>{li}</li>;
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="step_by_step_scope_wrap">
          <div className="title">{t("digitalTwin.smartGreen.scope.title")}</div>
          <div className="contents">
            <div className="scope_wrap">
              {stepByStepScope.map((data, index) => {
                return (
                  <div className="scope_card" key={`data.ment_${index}`}>
                    <div className="upper">
                      <div className="name">{`Scope${index + 1}`}</div>
                      <ul>
                        <li>{data.ment}</li>
                      </ul>
                    </div>
                    <div className="under">
                      <div className="img_box">
                        <img src={data.iconPath} alt="scope" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="greenhouse_gas_wrap">
              <div className="name">{t("digitalTwin.smartGreen.scope.content.greenhouseGas.title")}</div>
              <div className="list_wrap">
                {stepByStepGreenhouseGas.map((list, index) => {
                  return (
                    <ul className="list" key={`greenhouse_gas_${index}`}>
                      {list.map((li, index2) => {
                        return <li key={`${li}_${index2}`}>{li}</li>;
                      })}
                    </ul>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="technology_standardization_wrap">
          <div className="title">{t("digitalTwin.smartGreen.standardization.title")}</div>
          <div className="content">
            {technologyStandardization.map((data, index) => {
              return (
                <div className="technology_wrap" key={`data.category_${index}`}>
                  <div className="category_wrap" style={{ backgroundColor: data.color }}>
                    <div className="category">{data.category}</div>
                    <div className="img_box">
                      <img src={data.imagePath} alt={`${data.category}`} />
                    </div>
                  </div>
                  <div className="list_wrap">
                    {data.list.map((li, index2) => {
                      return (
                        <div className="list" key={`li.des_${index2}`}>
                          <div className="name" style={{ color: data.color, borderBottomColor: data.color }}>
                            {li.name}
                          </div>
                          <div className="des">{li.des}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* <NetZeroScope />
      <DtContent /> */}
    </>
  );
};

export default SmartGreen;
